import { AsyncAction } from '@cbgms/base/redux/async-action'

import {
  GETTyreChangeSettingsResponse,
  PUTTyreChangeSettingsBody,
  PUTTyreChangeSettingsResponse,
  getTyreChangeSettings,
  putTyreChangeSettings
} from '@cbgms/api'

const LOAD_TYRE_CHANGE_SETTINGS = 'LOAD_TYRE_CHANGE_SETTINGS'
const LOAD_TYRE_CHANGE_SETTINGS_SUCCESS = 'LOAD_TYRE_CHANGE_SETTINGS_SUCCESS'
const LOAD_TYRE_CHANGE_SETTINGS_FAILED = 'LOAD_TYRE_CHANGE_SETTINGS_FAILED'

export const loadTyreChangeSettings = () =>
  AsyncAction<GETTyreChangeSettingsResponse>({
    type: [LOAD_TYRE_CHANGE_SETTINGS, LOAD_TYRE_CHANGE_SETTINGS_SUCCESS, LOAD_TYRE_CHANGE_SETTINGS_FAILED],
    payload: {
      api: 'gms',
      request: getTyreChangeSettings()
    }
  })

const UPDATE_TYRE_CHANGE_SETTINGS = 'UPDATE_TYRE_CHANGE_SETTINGS'
const UPDATE_TYRE_CHANGE_SETTINGS_SUCCESS = 'UPDATE_TYRE_CHANGE_SETTINGS_SUCCESS'
const UPDATE_TYRE_CHANGE_SETTINGS_FAILED = 'UPDATE_TYRE_CHANGE_SETTINGS_FAILED'

export const updateTyreChangeSettings = (data: PUTTyreChangeSettingsBody) =>
  AsyncAction<PUTTyreChangeSettingsResponse>({
    type: [UPDATE_TYRE_CHANGE_SETTINGS, UPDATE_TYRE_CHANGE_SETTINGS_SUCCESS, UPDATE_TYRE_CHANGE_SETTINGS_FAILED],
    payload: {
      api: 'gms',
      request: putTyreChangeSettings(data)
    }
  })
